import React, { useEffect, useState } from "react";
import { getPrefixes, usersResource } from "../../helpers/configRoutes/backend_helper";
import { useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomInput from "../../components/form/CustomInput";
import CustomSelect from "../../components/form/CustomSelect";
import { showFormErrors } from "../../helpers/showFormErrors";
import FileInput from "../../components/form/FileInput";
import ModulesPermissions from "./ModulesPermissions";
import CustomButton from "../../components/form/CustomButton";
import { validatePhones } from "../../helpers/forms/Validation";

const AddUpdTeam = () => {
    const navigate = useNavigate();
    const { id } = useParams(); // Obtener ID si estamos editando
    const [prefixes, setPrefixes] = useState([]);
    const [modal, setModal] = useState({ show: false, loading: true, textLoad: 'Saving', title: 'Select Permmissions', user: true });
    const [loading, setLoading] = useState(false);
    // Obtener usuario y asignar valores al formulario
    useEffect(() => {
        const getUser = async () => {
            const response = await usersResource('show', {}, id);
            if (response.status) {
                Object.keys(response.user).forEach(field => {
                    validation.setFieldValue(field, response.user[field], false); // Setear valores en el formik sin disparar validación
                });
            }
        }
        if (id) {
            getUser();
        }
    }, [id]);

    // Obtener catálogo de prefijos
    useEffect(() => {
        const getPrefixesCatalog = async () => {
            const response = await getPrefixes();
            if (response.status) {
                setPrefixes(response.prefixes);
            }
        }
        getPrefixesCatalog();
    }, []);

    

    // Formik para manejo del formulario y validaciones
    const validation = useFormik({
        initialValues: {
            id: null,
            active: true,
            email: '',
            first_name: '',
            last_name: '',
            
            phone: '',
            prefix_id: '',
            company_id: '',
            imageProfile: '',
            modelsPermissions: []
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Invalid email').required('Email is required'),
            first_name: Yup.string().required('First name is required'),
            last_name: Yup.string().required('Last name is required'),
            phone: validatePhones(true),
            prefix_id: Yup.string().required('Prefix is required'),
            imageProfile: '',
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true)
            const response = await usersResource(values.id ? 'put' : 'post', values, values.id);
            if (response.status) {
                navigate('/team'); // Navegar al equipo si la respuesta es exitosa
            } else {
                setErrors(response.errors); // Establecer errores en caso de fallo
            }
            setLoading(false)
        }
    });

    return (
        <div className="p-6 bg-slate-50 min-h-screen">
            {/* Header */}
            <div className="mb-6">
                <h1 className="text-2xl font-semibold text-slate-800">
                    {id ? 'Update Member' : 'Add New Member'}
                </h1>
                <p className="text-sm text-slate-500 mt-1">
                    Manage user information and permissions
                </p>
            </div>

            {/* Form */}
            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    showFormErrors(validation);
                    return false;
                }}
            >
                <div className="bg-white border border-slate-200 rounded-xl p-6 max-w-auto mx-auto">

                    {/* Profile */}
                    <div className="flex items-center gap-6 mb-8">
                        <div className="relative">
                            <img
                                className="w-24 h-24 rounded-full border border-slate-200 object-cover"
                                src={validation.values.imageProfile || "/images/usrAnonimo.png"}
                                alt="Profile"
                            />
                        </div>

                        <div>
                            <h3 className="font-medium text-slate-800">Profile picture</h3>
                            <p className="text-sm text-slate-500 mb-2">
                                JPG or PNG. Max 2MB.
                            </p>

                            <FileInput
                                format="img"
                                name="imageProfile"
                                validation={validation}
                            />
                        </div>
                    </div>

                    {/* Divider */}
                    <div className="border-t border-slate-200 mb-6"></div>

                    {/* Fields */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                        <CustomInput
                            label="First Name"
                            name="first_name"
                            type="text"
                            error={validation.errors?.first_name}
                            value={validation.values?.first_name}
                            handleChange={validation.handleChange}
                        />

                        <CustomInput
                            label="Last Name"
                            name="last_name"
                            type="text"
                            error={validation.errors?.last_name}
                            value={validation.values?.last_name}
                            handleChange={validation.handleChange}
                        />

                        <CustomInput
                            label="Email"
                            name="email"
                            type="email"
                            error={validation.errors?.email}
                            value={validation.values?.email}
                            handleChange={validation.handleChange}
                        />

                       

                        <CustomSelect
                            label="Phone Prefix"
                            name="prefix_id"
                            options={prefixes}
                            error={validation.errors?.prefix_id}
                            value={validation.values?.prefix_id}
                            handleChange={validation.handleChange}
                        />

                        <CustomInput
                            label="Phone Number"
                            name="phone"
                            type="text"
                            error={validation.errors?.phone}
                            value={validation.values?.phone}
                            handleChange={validation.handleChange}
                        />

                        <CustomSelect
                            label="Status"
                            name="active"
                            options={[
                                { id: 1, name: 'Active' },
                                { id: 0, name: 'Suspended' },
                            ]}
                            disabled={
                                validation.values.id
                                    ? !validation.values?.can?.disable
                                    : false
                            }
                            error={validation.errors?.active}
                            value={validation.values?.active}
                            handleChange={validation.handleChange}
                        />
                    </div>

                    {/* Permissions */}
                    <div className="mt-6 flex items-center gap-4">
                        <button
                            type="button"
                            onClick={() =>
                                setModal({ show: true, title: 'Select Permissions' })
                            }
                            className="text-sm text-blue-600 hover:underline"
                        >
                            Edit permissions
                        </button>
                    </div>

                    {/* Actions */}
                    <div className="mt-8 flex justify-end gap-3">
                        <button
                            type="button"
                            onClick={() => navigate(-1)}
                            className="px-5 py-2 rounded-lg text-sm border border-slate-300 text-slate-600 hover:bg-slate-100"
                        >
                            Cancel
                        </button>

                        <CustomButton
                            loading={loading}
                            textLoad="Processing"
                            type="submit"
                            className="px-6 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                        >
                            {id ? 'Save Changes' : 'Create User'}
                        </CustomButton>
                    </div>
                </div>
            </form>

            {modal.show && (
                <ModulesPermissions
                    modal={modal}
                    setModal={setModal}
                    validation={validation}
                />
            )}
        </div>

    )
}

export default AddUpdTeam;
